import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_9: FaireProductEntity = {
  token: "ramen-9",
  type: "product",
  name: "Soy & Scallion Noodles",
  brandName: "Momofuku",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/734f3e99a1bd587a6053e69dd1331210037bcdeb137167a20971ea6a83062111.png",
  priceDollars: 7.25,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/734f3e99a1bd587a6053e69dd1331210037bcdeb137167a20971ea6a83062111.png",
  weight: 0.4,
  dimensions: {
    width: 6,
    height: 8,
    depth: 2,
  },
  description: "Soy and scallion noodles from Momofuku",
  categoryTokens: ["cat_food-snacks"],
  tags: [
    "ramen",
    "instant-ramen",
    "japanese-ramen",
    "soy",
    "scallion",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
